'use client';

import dynamic from 'next/dynamic';

export const Squarelovin = dynamic(
  () =>
    import(/* webpackChunkName: 'Squarelovin' */ './Squarelovin.client').then(
      (mod) => mod.Squarelovin,
    ),
  {
    ssr: false,
  },
);
